import type { ExternalLoginTokenExchangeDTO } from "../dto/token-exchange.dto";
import { ExternalLoginRepository } from "../repositories/external-login.repository";
import type { IExternalLoginService } from "./external-login.service.interface";

export class ExternalLoginService implements IExternalLoginService {
  constructor(private readonly _authRepository = new ExternalLoginRepository()) {}

  public async exchangeNonceToken(authenticationToken: string): Promise<ExternalLoginTokenExchangeDTO> {
    return this._authRepository.exchangeNonceToken(authenticationToken);
  }
}

export const externalLoginService = new ExternalLoginService();
